import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import { UserContext } from '../../../../../shared/context/UserContext';
import HeaderUserDropdownButton from './HeaderUserDropdownButton';
import HeaderUserDropdownListItems from './HeaderUserDropdownList';

const HeaderUserDropdownWrapper = styled.div`
  #hud-udl-container {
    display: flex;
    flex-direction: row;
    align-content: center;
    justify-content: center;
    align-items: center;
  }
  #hud-udl-container.hud-udl-hovering,
  #hud-udl-container:hover {
    position: relative;
  }
  #hud-udl-button {
    color: var(--color-white);
    cursor: pointer;
    background-color: transparent;
    border: none;
    outline: none;
    display: flex;
    align-items: center;
    justify-content: center;
    align-content: center;
    flex-direction: row;
  }
  #hud-udl-container.hud-udl-hovering > #hud-udl-menu,
  #hud-udl-container:hover > #hud-udl-menu {
    transition: 0.15s linear;
    transform: scale(1);
    top: calc(100%);
    right: -17px;
  }
  #hud-udl-menu {
    position: absolute;
    min-width: 200px;
    padding-top: 2px;
    padding-right: 5px;
    padding-left: 5px;
    padding-bottom: 5px;
    z-index: 1;
    transform: scale(0);
    transform-origin: calc(100% - 37px) 0px;
    filter: drop-shadow(0px 8px 16px rgba(0, 0, 0, 0.5));
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    align-items: flex-start;
  }
  #hud-udl-menu-triangle-up {
    align-self: flex-end;
    width: 0;
    height: 0;
    border-left: 15px solid transparent;
    border-right: 15px solid transparent;
    border-bottom: 15px solid var(--color-white);
    margin-right: 17px;
    z-index: 1;
  }
  #hud-udl-item-container {
    align-self: stretch;
    background-color: var(--color-white);
    color: #121212;
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: flex-start;
    align-items: flex-start;
    row-gap: 10px;
    max-height: calc(100vh - 60px);
    overflow-y: auto;
  }
`;

const HeaderUserDropdown = ({ username, ...props }) => {
  const { user } = useContext(UserContext);
  const [hoveringState, setHoveringState] = useState(false);

  const [userRoutes, setUserRoutes] = useState([
    {
      title: 'Summary',
      route: `/summary`,
      go_back: true,
      show: true
    },
    {
      title: 'FAQs',
      route: `/faq`,
      go_back: false,
      show: true
    },
    {
      title: 'Logout',
      route: `/logout`,
      go_back: false,
      show: true
    }
  ]);

  useEffect(() => {
    if (user.Stage.stage_status === 'REJECT' || user.Stage.stage_status === 'REJECTED') {
      setUserRoutes([
        {
          title: 'Summary',
          route: `/summary`,
          go_back: true,
          show: false
        },
        {
          title: 'FAQs',
          route: `/faq`,
          go_back: false,
          show: true
        },
        {
          title: 'Logout',
          route: `/logout`,
          go_back: false,
          show: true
        }
      ]);
    } else {
      setUserRoutes([
        {
          title: 'Summary',
          route: `/summary`,
          go_back: true,
          show: true
        },
        {
          title: 'FAQs',
          route: `/faq`,
          go_back: false,
          show: true
        },
        {
          title: 'Logout',
          route: `/logout`,
          go_back: false,
          show: true
        }
      ]);
    }
  }, [user.Stage.stage, user.Stage.stage_status]);

  return (
    <HeaderUserDropdownWrapper {...props}>
      <div
        id="hud-udl-container"
        className={hoveringState ? 'hud-udl-hovering' : ''}
        onClick={() => setHoveringState(!hoveringState)}
      >
        <div id="hud-udl-button">
          <HeaderUserDropdownButton title={username} />
        </div>
        <div id="hud-udl-menu">
          <div id="hud-udl-menu-triangle-up"></div>
          <div id="hud-udl-item-container">
            <HeaderUserDropdownListItems dropdown_list={userRoutes} />
          </div>
        </div>
      </div>
    </HeaderUserDropdownWrapper>
  );
};

export default HeaderUserDropdown;
